import {
  setInterceptors as apiSetInterceptors
} from '@/api/api'

export default {
  INIT: ({ dispatch }) => {
    dispatch('user/SET_AUTH_PARAMS', null, { root: true })
    dispatch('SET_API_INTERCEPTORS')
  },

  SET_API_INTERCEPTORS: ({ dispatch }) => {
    apiSetInterceptors({
      logoutCallback: () => {
        dispatch('user/LOGOUT', null, { root: true })
      }
    })
  }
}
